import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const Banner = () => {
  return (
    <Box marginTop={{ xs: "35%", sm: "15%" }}>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        width={"100%"}
      >
        <Typography
          variant="h2"
          color="#33E68C"
          fontWeight={800}
          paddingBottom={"2%"}
          textAlign={"left"}
        >
          <Typography
            component={"span"}
            color="#fff"
            fontWeight={800}
            variant={"h2"}
          >
            Contact {""}
          </Typography>
          Us
        </Typography>
      </Box>
    </Box>
  );
};

export default Banner;
